import { c as _c } from "react/compiler-runtime";
import ImageComponent from '@spa/components/image-component/image.component';
import { ReactElement } from 'react';
import TooltipCursorComponent from '@spa/components/tooltips/tooltip-cursor/tooltip-cursor.component';
import styles from './image-section.component.module.scss';
interface Props {
  readonly url: string;
  readonly alt?: string;
  readonly priority: boolean;
  readonly cursorFollowingTooltip?: string;
  readonly aspectRatio?: number;
  readonly sizes?: string;
  readonly onClick?: () => void;
  readonly digitalSourceTypeAttr?: Record<string, string>;
}
function ImageSectionComponent(t0) {
  const $ = _c(19);
  const {
    url,
    alt: t1,
    priority,
    cursorFollowingTooltip,
    aspectRatio: t2,
    sizes,
    onClick,
    digitalSourceTypeAttr
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  const aspectRatio = t2 === undefined ? 1 : t2;
  const paddingPercent = (aspectRatio * 100).toFixed(2) + "%";
  let t3;
  if ($[0] !== paddingPercent) {
    t3 = {
      paddingBottom: paddingPercent
    };
    $[0] = paddingPercent;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = priority ? "high" : undefined;
  let t5;
  if ($[2] !== onClick) {
    t5 = e => {
      if (onClick && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        onClick();
      }
    };
    $[2] = onClick;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== alt || $[5] !== digitalSourceTypeAttr || $[6] !== onClick || $[7] !== priority || $[8] !== sizes || $[9] !== t4 || $[10] !== t5 || $[11] !== url) {
    t6 = <ImageComponent src={url} alt={alt} priority={priority} fetchPriority={t4} sizes={sizes} onClick={onClick} onKeyDown={t5} fill={true} className={styles["image-section__image"]} {...digitalSourceTypeAttr} />;
    $[4] = alt;
    $[5] = digitalSourceTypeAttr;
    $[6] = onClick;
    $[7] = priority;
    $[8] = sizes;
    $[9] = t4;
    $[10] = t5;
    $[11] = url;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <span className={styles["image-section"]} style={t3}>{t6}</span>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const image = t7;
  let t8;
  if ($[16] !== cursorFollowingTooltip || $[17] !== image) {
    t8 = cursorFollowingTooltip ? <TooltipCursorComponent content={cursorFollowingTooltip} fitContent={true}>{image}</TooltipCursorComponent> : image;
    $[16] = cursorFollowingTooltip;
    $[17] = image;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default ImageSectionComponent;